import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AdminKioskVerifyFormContainer from './AdminKioskVerifyFormContainer';
import AdminSideSlides from '../../AdminLayout/AdminSideSlides';
import { injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import KioskIdelScreen from '../../KioskLayout/KioskIdelScreen';

const messages = defineMessages({
  ScanCodeToVerify: {
    id: 'Admin.Verify.ScanCodeToVerify',
    defineMessages: 'Scan the stock code to verify.'
  }
});

export class AdminKioskVerifyLayout extends Component {
  static propTypes = {
    test: PropTypes.string
  };
  state = {
    stepTitle: '',
    pageTitle:
      this.props && this.props.intl.formatMessage(messages.ScanCodeToVerify),
    height: 300
  };

  render() {
    return (
      <>
        <AdminSideSlides
          pageTitle={this.state.pageTitle}
          customTop={this.state.customTop}
          customHeight={120}
        />
        <AdminKioskVerifyFormContainer />
        <KioskIdelScreen />
      </>
    );
  }
}
const mapStateToProps = (state) => {
  const kiosk = state.get('kiosk');
  return { ...kiosk };
};

export default connect(mapStateToProps)(injectIntl(AdminKioskVerifyLayout));
